var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.dynamicComponent,{tag:"component",attrs:{"start":_vm.start,"end":_vm.end,"locale":_vm.locale,"classList":_vm.classList,"id":_vm.id,"date":_vm.date,"limitDate":_vm.limitDate,"min-date":_vm.minDate},on:{"changeDate":function($event){return _vm.emit($event, 'changeDate')},"onSubmit":function($event){return _vm.emit($event, 'onSubmit')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }